(function () {
  'use strict';

  const header = document.querySelector('.ol-header');
  if (!header) return;

  // === Scroll behavior : compact mode with hysteresis (anti-flicker au seuil) ===
  const COMPACT_ENTER = 120;
  const COMPACT_EXIT = 40;
  let ticking = false;

  function updateHeaderVisibility() {
    const currentY = window.scrollY;
    const isCompact = header.classList.contains('is-compact');
    if (!isCompact && currentY > COMPACT_ENTER) {
      header.classList.add('is-compact');
    } else if (isCompact && currentY < COMPACT_EXIT) {
      header.classList.remove('is-compact');
    }
    ticking = false;
  }
  updateHeaderVisibility();

  window.addEventListener(
    'scroll',
    function () {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderVisibility);
        ticking = true;
      }
    },
    { passive: true }
  );

  // === Lang toggle : placeholder V1, a connecter au chantier multilingue ===
  const langToggle = header.querySelector('[data-ol-lang-toggle]');
  if (langToggle) {
    langToggle.addEventListener('click', function () {
      // Placeholder V1 : à connecter au chantier multilingue (Translate & Adapt). No-op pour l'instant.
    });
  }
})();
